/**
 * Карточка Chatbots & Messengers.
 */

import { useState } from "react";
import Typewriter from "../Typewriter/Typewriter";
import TerminalLabel from "../TerminalLabel/TerminalLabel";
import ServiceCard from "../ServiceCard/ServiceCard";
import TerminalHeader from "../TerminalHeader/TerminalHeader";
import IconTelegram from "../../assets/icons/IconTelegram";
import IconViber from "../../assets/icons/IconViber";
import IconInstagram from "../../assets/icons/IconInstagram";
import IconWhatsApp from "../../assets/icons/IconWhatsApp";
import { SERVICE_CHATBOTS } from "../../config/services";

function ChatbotsCard() {
    const [cardContentDone, setCardContentDone] = useState(false);
    const copy = SERVICE_CHATBOTS;

    return (
        <ServiceCard variant="terminal">
            <TerminalHeader>
                <TerminalLabel startAfter={cardContentDone} />
            </TerminalHeader>
            <div className="group-9__card-terminal-body">
                <div className="group-9__icons group-9__icons_messengers" aria-hidden="true">
                    <span className="group-9__icon-wrap group-9__icon-wrap_msg">
                        {/* Telegram */}
                        <IconTelegram />
                    </span>
                    <span className="group-9__icon-wrap group-9__icon-wrap_msg">
                        {/* Viber */}
                        <IconViber />
                    </span>
                    <span className="group-9__icon-wrap group-9__icon-wrap_msg">
                        {/* Instagram */}
                        <IconInstagram />
                    </span>
                    <span className="group-9__icon-wrap group-9__icon-wrap_msg">
                        {/* WhatsApp */}
                        <IconWhatsApp />
                    </span>
                </div>
                <h3 className="group-9__title group-9__title_telegram">
                    <Typewriter text={copy.title} speed={copy.titleSpeed} delay={copy.titleDelay} />
                </h3>
                <p className="group-9__text group-9__text_telegram">
                    <Typewriter
                        text={copy.text}
                        speed={copy.textSpeed}
                        delay={copy.textDelay}
                        onComplete={() => setCardContentDone(true)}
                    />
                </p>
            </div>
        </ServiceCard>
    );
}

export default ChatbotsCard;
// components/ServiceCards/ChatbotsCard.js
